import { useEffect, useState } from 'react';
import { PORTAL_LOCALE_CHANGE_EVENT } from './portalLocaleEvents';

export function useLocaleTick(): number {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const bump = () => setTick((n) => n + 1);
    window.addEventListener(PORTAL_LOCALE_CHANGE_EVENT, bump);
    window.addEventListener('storage', bump);
    return () => {
      window.removeEventListener(PORTAL_LOCALE_CHANGE_EVENT, bump);
      window.removeEventListener('storage', bump);
    };
  }, []);
  return tick;
}
